import React from 'react'
import { usePage } from '@inertiajs/react'

// Shown to signed-in users whose permission is still 'none' (awaiting an
// admin to grant access). Rendered inside Layout so it appears on every page.
export default function PendingApprovalBanner() {
  const { auth } = usePage().props

  const permission = auth?.user?.permission
  const isPending = auth?.signed_in && (!permission || permission === 'none')

  if (!isPending) return null

  return (
    <div
      role="status"
      className="bg-amber-50 border-b border-amber-300 text-amber-900 text-sm px-4 py-3 flex items-start sm:items-center justify-center gap-2"
    >
      <svg
        className="w-5 h-5 flex-shrink-0 text-amber-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span>
        Sua conta está aguardando aprovação de um administrador. Você terá
        acesso ao conteúdo restrito assim que sua permissão for liberada.
      </span>
    </div>
  )
}
